import type { FieldErrors } from "react-hook-form";

import type { TechnicalRequestData } from "@services/apiEcms/apiEcms.types";

import type { AddPodFormData } from "./AddPodForm.types";

export const getIsFilled = (
  fields: Array<keyof AddPodFormData>,
  errors: FieldErrors<AddPodFormData>,
  data: Partial<AddPodFormData>,
) => fields.every((field) => data[field] && !errors[field]);

export const mapAddPodFormToTechRequest = (
  form: AddPodFormData,
): TechnicalRequestData => ({
  identifier: `${form.client} (${form.contract})`,
  actionType: "ADD_SITE",
  attachments: form.attachments || [],
  description: {
    podAddress: {
      siteAddress: form.siteAddress,
      additionalAddress: form.additionalAddress || "",
      siteZipCode: form.siteZipCode,
      siteCity: form.siteCity,
    },
    podInfo: {
      podId: form.podSerial,
      energy: form.energyType || "",
      podType: form.podType || "",
      podDistributionSystemOperator: form.podDistributionSystemOperator,
      requestedBenefit: form.requestedBenefit || "",
      requestedDate: form.requestedDate,
      options: form.options,
      potency: form.potency,
    },
    perimeterSelected: {
      customer: form.client,
      contract: form.contract || "",
    },
    siteContact: {
      civility: form.civility,
      firstName: form.firstName,
      lastName: form.lastName,
      phone: form.phone,
      email: form.email,
    },
  },
});
